import { UserProfile as UserProfileType } from 'globalTypes'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faLinkedin } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Trans } from '@lingui/macro'
import PreTitle from 'Root/App/PreTitle'
import Title from 'Root/App/Title'
import Link from 'next/link'

import styles from './index.module.css'

export interface Props extends UserProfileType {
  isOnCollection?: boolean
  anchorCallback?: () => void
}

library.add(faLinkedin)

const UserProfileLink = ({
  children,
  href = '',
  anchorCallback,
  className = '',
}) => {
  if (anchorCallback) {
    return (
      <span className={className} onClick={anchorCallback}>
        {children}
      </span>
    )
  }

  return <Link href={href}>{children}</Link>
}

const UserProfile = (props: Props) => {
  return (
    <div className={styles.container}>
      <div>
        <div className={styles.avatar}>
          <UserProfileLink
            href={`/profile/${props.vanity_name}`}
            anchorCallback={props.anchorCallback}
            className="cursor-pointer"
          >
            <img
              alt={props.name}
              className={styles.avatar}
              src={props.picture}
            />
          </UserProfileLink>
        </div>
      </div>
      <div>
        <PreTitle className="text-gray-500" size="XS">
          <UserProfileLink
            href={`/profile/${props.vanity_name}`}
            anchorCallback={props.anchorCallback}
            className="cursor-pointer"
          >
            <Trans>creato da</Trans>
          </UserProfileLink>
        </PreTitle>
        <Title size="2XS" maxRows={2}>
          <UserProfileLink
            href={`/profile/${props.vanity_name}`}
            anchorCallback={props.anchorCallback}
            className="text-brand-main underline cursor-pointer"
          >
            {props.name}
          </UserProfileLink>
        </Title>

        {Boolean(props.website) && (
          <div className="pt-1">
            <a
              className={styles.linkedin}
              href={props.website}
              rel="noreferrer"
              target="_blank"
            >
              <FontAwesomeIcon
                icon={['fab', 'linkedin']}
                transform={{ size: 18 }}
              />
            </a>
          </div>
        )}
      </div>
    </div>
  )
}

export default UserProfile
